import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSProperties } from 'react';
import styled from 'styled-components6';

const StyledCloseButton = styled.div`
    cursor: pointer;
    display: flex;
    color: var(--rwl-palette-gray-500);
    height: 32px;
    width: 32px;
    align-items: center;
    justify-content: center;
    border-radius: var(--rwl-radius-lg);
    &:hover {
        background-color: var(--rwl-palette-gray-200);
    }
`;

export const CloseButton = ({
    onClick,
    styles,
    title,
}: {
    onClick?: () => void;
    styles?: CSSProperties;
    title?: string;
}) => {
    return (
        <StyledCloseButton
            style={{ ...styles }}
            onClick={onClick}
            title={title}
        >
            <FontAwesomeIcon size="lg" icon={faXmark} title={title} />
        </StyledCloseButton>
    );
};
